/**
 * Returns file extension (if any) without . (dot). \
 * e.g. jpg, png...
 */
const getFileExtension = (filename: string): string => {
    return filename.split(".").pop() ?? "";
};

export { getFileExtension };
